export default state => {
  const chartData = state?.medical?.medicalPlansChart;
  if (!state?.medical?.medicalPlansChart?.planChart) return;

  chartData.planChart=toArray(chartData.planChart);
  const headers = [
    '',
    ...chartData.planChart.map(val => ({
      type: val.type,
      name: val.name
    }))
  ];

  const sets = [];
  let gotDocType=false;
  for (const key of Object.keys(chartData.labelsChart)) {
    let labels=toArray(chartData.labelsChart[key].label);
  
    if(labels.find((a)=>a.indexOf("Doctors in the plan")!=-1)!==undefined)
    {
       
      gotDocType=true;
      break;
    }
  }

  for (const key of Object.keys(chartData.labelsChart)) {
 
    if(toArray(chartData.labelsChart[key].label).length==0)
    {
      continue; 
    }
    /** 
     * @type {[string]}
     */
   
    let labels=toArray(chartData.labelsChart[key].label);
  
    if(gotDocType)
    {
      labels=labels.map(label=>label.split("-")[0]);
      labels=labels.filter((value,index,self)=>self.indexOf(value) === index);
      gotDocType=true;
    }
    
    sets.push({ 
      header: key,
      rows: labels.map((label, i) => [
        label,
        ...getLaidData(chartData,key,i*(gotDocType?2:1),gotDocType)
      ])
    });
  }
 
  state.medical.medicalPlansChart = { headers, sets ,planChartFootnotes:chartData.planChartFootnotes,gotDocType };
};

function getLaidData(chartData,key,i,gotDocType)
{
  return chartData.planChart
    .map(planChart => {
            
      if(planChart[key]===undefined)
      {
        return "";
      }
      if (Array.isArray(planChart[key].cell)) {
        if(gotDocType)
          return toArray([planChart[key].cell[i],planChart[key].cell[i+1]]);
        else
          return toArray(planChart[key].cell[i]);
      } else {
        if(gotDocType)
          return toArray([planChart[key].cell,'']);
        else
          return toArray(planChart[key].cell);
        
      }
    })
    .flat();
}

function toArray(val) {
  return Array.isArray(val) ? val : val?[val]:[];
}
